import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.Product,
});

export enum ProductFormTabs {
  Variants = "variants",
  Attributes = "attributes",
  Components = "components",
  Picture = "picture",
  Inventory = "inventory",
  General = "general",
  EventTicket = "event-ticket",
  Suppliers = "suppliers",
}

export enum VariantFormTabs {
  Components = "components",
  General = "general",
  Attributes = "attributes",
  Picture = "picture",
  Storage = "storage",
  StockMove = "stock-move",
  EventTicket = "event-ticket",
}

export enum ProductCreateFormSearchParams {
  InitialProductType = "initial_product_type",
}
